module.exports = __webpack_public_path__ + "static/img/18.837ff50.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logos/18.png
// module id = 8vmZ
// module chunks = 10